function ToggleReligion() {

    var checked = $('#religionContainer input:checked').length > 0;

    if (checked) {
        $(".religions .SelectionBaseBoolCheckBox input:checkbox").removeAttr('disabled');
    }
}

$(function () {
    $('body').delegate('.religions input:checkbox', 'click', function (e) {
        ToggleReligion();
    });
});